(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScopeDialogController',ScopeDialogController);

    ScopeDialogController.$inject = ['$state', '$uibModalInstance', 'IntegrationScope', '$uibModal'];

    function ScopeDialogController($state, $uibModalInstance, IntegrationScope, $uibModal) {
        var vm = this;

        vm.scopes = IntegrationScope.query();

        vm.saveNew = false;
        vm.editorEnabled = [];
        vm.updateScope = [];

        vm.enableEditor = function(index, edit) {
            if(edit === 0) {
                if(!vm.editorEnabled[index]) {
                    vm.editorEnabled[index] = true;
                }
            } else if(edit === 1) {
                vm.updateScope[index] = vm.scopes[index].scope;
                vm.editorEnabled[index] = !vm.editorEnabled[index];
            } else {
                if (vm.scopes[index].scope === "") {
                    vm.scopes.splice(index, 1);
                    vm.editorEnabled.splice(index, 1);
                    vm.saveNew = false;
                } else {
                    vm.editorEnabled[index] = !vm.editorEnabled[index];
                    vm.updateScope[index] = vm.scopes[index].scope;
                }
            }
        };

        vm.save = function () {
            var scope = checkScopeToSave(vm.scopes.length -1);
            if (scope !== null)
                IntegrationScope.save(scope, onSuccess, onError);
        };

        vm.saveUpdate = function(index) {
            var scope = checkScopeToSave(index);
            if (scope !== null)
                IntegrationScope.update(scope, onSuccess, onError);
        };

        function checkScopeToSave(index) {
            if (vm.updateScope[index] !== "" && vm.updateScope[index] !== undefined) {
                vm.scopes[index].scope = vm.updateScope[index];
                return vm.scopes[index];
            }
            return null;
        }

        function onSuccess() {
            $uibModalInstance.close(true);
        }

        function onError(){}

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.addNewScope = function() {
            vm.saveNew = true;

            var newScope = {
                id: vm.scopes[vm.scopes.length -1].id +1,
                scope: ""
            }
            vm.scopes.push(newScope);

            vm.editorEnabled[vm.scopes.length -1] = true;
        }

        vm.deleteScope = function (scope) {
            $uibModalInstance.dismiss('cancel');
            $uibModal.open({
                templateUrl: 'app/account/settings/integration/scope-delete-dialog.html',
                controller: 'ScopeDeleteDialogController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: scope
                }
            }).result.then(function () {
                $state.transitionTo('integration', {}, {reload: true});
            }, function () {
                $state.go('scope-dialog', {}, {reload: true});
            });
        }
    }
})();
